import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-my-course-quiz-route.tsx
var LazyMyCourseQuizRoute = lazy(() => import("./my-course-quiz-route-CRtn-bwH.js").then((n) => n.n).then((module) => ({ default: module.MyCourseQuizRoute })));
function MyCourseQuizRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseQuizRoute, { ...props })
	});
}
var useMyCourseQuizRoute = () => {
	return useMemo(() => ({ "my-course-quiz-route": { component: MyCourseQuizRoute } }), []);
};
//#endregion
export { useMyCourseQuizRoute };
